import PocketBase, { type RecordModel } from 'pocketbase';
import type { UserRecord } from './types';

// Production: the app is served by PocketBase itself, so the API is same-origin.
// Dev: Vite runs on :5173 and talks to the local PocketBase (tools/dev.ps1) directly.
const url = import.meta.env.VITE_PB_URL || (import.meta.env.DEV ? 'http://127.0.0.1:8090' : '/');

export const pb = new PocketBase(url);
// Several panels load in parallel; PocketBase's default auto-cancel would abort duplicates.
pb.autoCancellation(false);

export function currentUser(): UserRecord | null {
  const r = pb.authStore.record as RecordModel | null;
  if (!r || r.collectionName !== 'users') return null;
  return r as unknown as UserRecord;
}

let fileToken: { token: string; at: number } | null = null;

/** Short-lived token for protected files (base-layer images, heightmaps, attachments). */
export async function getFileToken(): Promise<string> {
  // Tokens last a few minutes; refresh a little early.
  if (fileToken && Date.now() - fileToken.at < 90_000) return fileToken.token;
  const token = await pb.files.getToken();
  fileToken = { token, at: Date.now() };
  return token;
}

export async function protectedFileUrl(
  record: { id: string; collectionId: string; collectionName: string },
  filename: string,
  thumb?: string,
): Promise<string> {
  const token = await getFileToken();
  return pb.files.getURL(record as RecordModel, filename, thumb ? { token, thumb } : { token });
}
